import { databaseRef } from 'config/firebase'
import * as React from 'react'
import { connect } from 'react-redux'
// import * as UserActions from '../../store/user/actions'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  injectStripe,
  ReactStripeElements
} from 'react-stripe-elements'
import {
  compose // , bindActionCreators
} from 'redux'
import { docSize } from 'services/sizes'
import { _route } from '../../routes/config'
import SnackbarService from '../../services/snackbars'
import './style.scss'

interface INativeProps {
  setLoading: (loading: boolean) => void
  goToCongratulationsTab: () => void
  parentId: string
}

interface IReduxStateProps {
  user: any
  userId: string
}

// interface IReduxDispatchProps { UserLib: any }

interface IProps
  extends INativeProps,
    IReduxStateProps,
    // IReduxDispatchProps,
    ReactStripeElements.InjectedStripeProps,
    RouteComponentProps {}

interface IState {
  docSize: number
}

class Checkout extends React.Component<IProps, IState> {
  state: IState = {
    docSize: docSize()
  }

  style = () => {
    return {
      base: {
        fontSize: '1rem',
        fontFamily: 'Open Sans',
        letterSpacing: '0.2em',
        '::placeholder': {
          fontFamily: 'Open Sans',
          fontSize: '1rem',
          letterSpacing: '0.2em'
        }
      }
    }
  }

  onResize = () => {
    const doc = docSize()
    if (this.state.docSize !== doc) {
      this.setState({ docSize: doc })
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  handleUpgradeToPlusUserInDB = async () => {
    const { parentId } = this.props

    try {
      const userRef = await databaseRef
        .child('users')
        .child(parentId)
        .child('is_plus')
      userRef.set(true)
    } catch (err) {
      console.error({ err })
    }
  }

  startUnrealPayment = () => {
    const { setLoading, goToCongratulationsTab } = this.props
    setLoading(true)
    this.handleUpgradeToPlusUserInDB()
    setTimeout(() => {
      setLoading(false)
      goToCongratulationsTab()
    }, 1500)
  }

  startPayment = async () => {
    const {
      stripe,
      user,
      userId,
      // UserLib,
      setLoading
    } = this.props
    if (!stripe) {
      return
    }

    const options = {
      metadata: {
        userId,
        email: user.email
      },
      receipt_email: user.email
    }

    try {
      setLoading(true)
      const res = await fetch(
        `${process.env.REACT_APP_CLOUD_FUNCTIONS}/createOrderAndSession/`,
        {
          method: 'POST',
          body: JSON.stringify(options)
        }
      )
      const data = await res.json()
      const body = JSON.parse(data.body)
      const clientId = body.client_secret
      const payload = await stripe.handleCardPayment(clientId)
      if (payload.error) {
        SnackbarService.showSnackbar(
          payload.error.message || 'Something went wrong',
          'error'
        )
        setLoading(false)
        // } else { UserLib.completePayment(() => setLoading(false))
      }
    } catch (err) {
      console.error(err)
    }
  }

  render() {
    return (
      <div className="checkout design-fixes">
        <CardNumberElement className="payment-card" style={this.style()} />
        <div className="subtitle"> Expiration </div>
        <CardExpiryElement className="expiry" style={this.style()} />
        <CardCvcElement className="cvc" style={this.style()} />
        <div className="btn-wrapper">
          <button
            className="explanation-submit-btn"
            id="3-checkout-a"
            onClick={this.startUnrealPayment} // this.startPayment}
          >
            Checkout
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state): IReduxStateProps => ({
  user: state.user.data,
  userId: state.user.auth.uid
})

// const mapDispatchToProps = (dispatch): IReduxDispatchProps => ({
//   UserLib: bindActionCreators<any, any>(UserActions, dispatch)
// })

const connector = connect(mapStateToProps) // , mapDispatchToProps)

const connected = compose<React.ElementType<INativeProps>>(
  injectStripe,
  withRouter,
  connector
)(Checkout)

export default connected



// WEBPACK FOOTER //
// ./src/components/PaymentComponent/checkout.tsx